import { IFile } from '../NativeDevice/fileSystem';
import OfflineCache from '../OfflineCache/OfflineCache';

export class RunnerDownloader {
	constructor(
		private offlineCache: OfflineCache,
		private getStaticBaseUrl: () => string,
	) {}

	public async getOrDownloadRunner(archiveUri: string, mainFileName: string, md5Checksum: string): Promise<IFile | null> {
		const runnerLocalFolder = this.getRunnerDirectory(archiveUri, md5Checksum);
		const existsRunnerFile = await this.offlineCache.fileExists(runnerLocalFolder);

		if (!existsRunnerFile) {
			await this.downloadRunnerToLocalStorage(archiveUri, runnerLocalFolder, mainFileName);
		}

		return await this.offlineCache.getFile(runnerLocalFolder + '/' + mainFileName);
	}

	private async downloadRunnerToLocalStorage(runnerFilePath: string, localDirPath: string, mainFileName: string) {
		const relativePath = this.removeStaticUrl(runnerFilePath);
		await this.ensureRunnerIsDownloaded(relativePath);
		await this.ensureRunnerIsExtracted(relativePath, localDirPath);

		const mainFilePath = localDirPath + '/' + mainFileName;
		return await this.offlineCache.getFile(mainFilePath);
	}

	private async ensureRunnerIsDownloaded(runnerFileName: string) {
		const existsRunnerFolder = await this.offlineCache.fileExists(runnerFileName);
		if (!existsRunnerFolder) {
			const staticBaseUrl = this.getStaticBaseUrl();
			const runnerUri = staticBaseUrl + '/runner/' + runnerFileName;
			await this.offlineCache.retriableDownloadFile(5, runnerFileName, runnerUri, undefined, true);
		}
	}

	private async ensureRunnerIsExtracted(runnerFilePath: string, runnerDirectoryPath: string) {
		const existsRunner = await this.offlineCache.fileExists(runnerDirectoryPath);

		const runnerFile = await this.offlineCache.getFile(runnerFilePath);

		if (!existsRunner && runnerFile) {
			await this.offlineCache.extractFile(runnerFilePath, runnerDirectoryPath, 'zip', true);
		}
	}

	private getRunnerDirectory(archiveUri: string, md5Checksum: string): string {
		const relativePath = this.removeStaticUrl(archiveUri);
		return relativePath.substring(0, relativePath.lastIndexOf('/')) + '/' + md5Checksum;
	}

	private removeStaticUrl(archiveUri: string): string {
		const matches = archiveUri.match(/runner\/(.+)$/);
		return matches ? matches[1] : archiveUri;
	}
}
